import { withErrorBoundary } from "react-error-boundary";
import { Navigate, Outlet } from "react-router-dom";

import useCheckoutRedirection from "@hooks/useCheckoutRedirection";

import { AppFooter } from "@/components/AppFooter";
import { usePage } from "@inertiajs/react";

import { Box, Flex } from "@chakra-ui/react";

import { logAppError } from "@utils/logAppError";

import { ErrorBoundaryFBContainer } from "@containers/Misc/ErrorBoundaryFBContainer";

import { CheckoutNav } from "@components/CheckoutNav";
import { PageLoader } from "@components/PageLoader";

const CheckoutLayout = () => {
    const { versionText } = usePage().props;

    const getVersionText = (): string => {
        return versionText as string;
    };

    const { canShowContent, redirect } = useCheckoutRedirection();
    // Check if redirection needs to be performed, flow with token attached is not considered here.

    if (canShowContent && redirect.shouldRedirect) {
        return (
            <Navigate
                to={{
                    pathname: redirect.pathRedirectTo,
                    search: redirect.search
                }}
            />
        );
    }

    // Show the pages based on the routes with the normal flow.
    if (canShowContent) {
        return (
            <Flex direction="column" minH="100dvh">
                <Box className="Header">
                    <CheckoutNav />
                </Box>
                <Flex direction="column" flex={1} position="relative">
                    <Outlet />
                </Flex>
                {/* Show version text footer only when we have value from backend. */}
                {versionText !== null && (
                    <AppFooter versionText={getVersionText()} />
                )}
            </Flex>
        );
    }

    /**
     * This component is being rendered as the fallback view until a page is selected to be shown.
     */
    return (
        <Flex direction="column">
            <Box className="Header" data-testid="checkout-nav-header">
                <CheckoutNav />
            </Box>
            <PageLoader />
        </Flex>
    );
};

export default withErrorBoundary(CheckoutLayout, {
    FallbackComponent: ErrorBoundaryFBContainer,
    onError: logAppError
});
